import React, { useEffect, useRef, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { Link, useNavigate } from 'react-router-dom';
import data from './data/music.json';
import ReactMarkdown from 'react-markdown';
import AdvancedMarkdownRenderer from './AdvancedMarkdownRender';

const Music = () => {
    const navigate = useNavigate();

    return (
        <div className='w-full text-900'>
            <div className='flex flex-column m-auto w-full p-3 pt-3 pb-6 lg:w-7'>
                <div>
                    <h1>Music</h1>
                    <AdvancedMarkdownRenderer content={data.content} />
                </div>
            </div>
        </div>
    );
};

export default Music;
